import React from "react";
import PropTypes from "prop-types";
import { CloudinaryVideo as BaseCloudinaryVideo } from "@sunwing/shared-components";
import "@sunwing/shared-components/dist/VideoPlayer/index.css";

const CloudinaryVideo = ({
	className,
	cloudName,
	publicId,
	lang,
	posterUrl,
	setVideoPlayer,
	...props
}) => (
	<BaseCloudinaryVideo
		className={className}
		lang={lang}
		cloudName={cloudName}
		publicId={publicId}
		posterUrl={posterUrl}
		setPlayer={setVideoPlayer}
		// eslint-disable-next-line react/jsx-props-no-spreading
		{...props}
	/>
);

CloudinaryVideo.propTypes = {
	className: PropTypes.string,
	lang: PropTypes.oneOf(["en", "fr"]),
	cloudName: PropTypes.string,
	publicId: PropTypes.string.isRequired,
	posterUrl: PropTypes.string,
	setVideoPlayer: PropTypes.func,
};

CloudinaryVideo.defaultProps = {
	className: undefined,
	cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME,
	lang: "en",
	posterUrl: undefined,
	setVideoPlayer: () => {},
};

export default CloudinaryVideo;
export { CloudinaryVideo };
